// extracted by mini-css-extract-plugin
export default {"Error":"Error_Error__48-nQ","Error__Illustration":"Error_Error__Illustration__RRq7u","Error__Title":"Error_Error__Title__jInOC","Error__Buttons":"Error_Error__Buttons__K4DFQ"};